export enum PropertyType {
  String,
  Integer,
  Date,
  Image,
}
